module.exports = __webpack_public_path__ + "img/tupian.078efd37.png";